import { Component } from '@angular/core';
import { MyToasterService } from '../services/my-toaster.service';

@Component({
  selector: 'helpper-root',
  template: `
    <div class="toaster-loading" *ngIf="myToaster.loading">
      <div class="title">{{myToaster.loading.title}}</div>
      <div class="subtitle">{{myToaster.loading.subtitle}}</div>
    </div>
    <toaster-container [toasterconfig]="myToaster.config"></toaster-container><router-outlet></router-outlet>`
})
export class AppComponent {
  constructor(public myToaster: MyToasterService) { }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts